import { Column, Heading, Image, Paragraph, Row } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { ButtonLink, Icon, StaticURLs } from "@s-i-s-i/see-learning.shared";
import { OnboardingLayout } from "../Components";
import { onboardingPrivacyStatementPageInfo } from "../PrivacyStatementPage/pageinfo";
import { onboardingIndexPageInfo } from "./pageinfo";

export function OnboardingIndexPage() {
	useActivePageRegistration(onboardingIndexPageInfo);

	return (
		<OnboardingLayout page="index">
			<Column justify="spaced-start" align="center" verticalSpacing="2rem">
				<Row justify="spaced-center" align="center" horizontalSpacing="1.5rem">
					<Image
						src={StaticURLs.Images.studentBoy1}
						width={155}
						height={197}
						sizing="width-scaled"
						style={{ width: "155px" }}
					/>
					<Image
						src={StaticURLs.Images.studentGirl1}
						width={176}
						height={201}
						sizing="width-scaled"
						style={{ width: "176px" }}
					/>
				</Row>

				<Heading.H1 noMargin style={{ textAlign: "center" }}>
					Welcome to the SEE Learning Communication Portal
				</Heading.H1>

				<Paragraph style={{ textAlign: "center" }}>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
					magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
				</Paragraph>

				<ButtonLink variant="primary" to={onboardingPrivacyStatementPageInfo.to}>
					<Row justify="spaced-center" align="center" horizontalSpacing="0.375rem">
						<span>Let's Get Started!</span>
						<Icon.ArrowRight size={20} />
					</Row>
				</ButtonLink>
			</Column>
		</OnboardingLayout>
	);
}
